import { getTenantPrefix } from "@/utils/tenant";
import store from "@/store";
import { PERMISSION_WRITE_QC } from "@/utils/permissions";
import { pickSamplesListQueryForRouter } from "@/components/layout/QAQC/Overview/qaqcSamplesListQuery.js";
import {
  mergeOverviewTabIntoQuery,
  overviewTabFromTestRoute,
} from "@/components/layout/QAQC/Overview/qaqcOverviewTab.js";

function canAccessQaqc() {
  return store.getters["tenantId/hasPermission"](PERMISSION_WRITE_QC);
}

export function navigateHome(router, route) {
  const urlSegments = window.location.pathname.split("/").filter(Boolean);
  const tenantId = urlSegments.length > 0 ? urlSegments[0] : getTenantPrefix() || "";
  if (!tenantId || !router) return;

  const section = urlSegments[1]?.toLowerCase() || "";
  if (section === "pvt-prediction") {
    router.push(`/${tenantId}/pvt-prediction`);
    return;
  }
  if (section === "exploratory-data-analysis") {
    router.push(`/${tenantId}/exploratory-data-analysis/inventory-analysis`);
    return;
  }
  if (section === "agentic-dashboard") {
    router.push({ name: "AgenticDashboard" });
    return;
  }

  const lastViewRaw = localStorage.getItem("activeMenu");
  const lastView =
    lastViewRaw === "PVT Data Visualization" ? "Data Management" : lastViewRaw;
  const isQaqcRoute = section === "qaqc";
  if (isQaqcRoute) {
    if (!canAccessQaqc()) {
      router.push(`/${tenantId}/data-management`);
      return;
    }
    const path = `/${tenantId}/qaqc/overview`;
    const onQaqcTest =
      urlSegments[2]?.toLowerCase() === "test" && urlSegments.length >= 5;
    const query = onQaqcTest
      ? mergeOverviewTabIntoQuery(
          pickSamplesListQueryForRouter(route?.query || {}),
          overviewTabFromTestRoute(route)
        )
      : pickSamplesListQueryForRouter(route?.query || {});
    router.push({ path, query });
    return;
  }

  if (lastView && lastView.toLowerCase() === "data management") {
    router.push(`/${tenantId}/data-management`);
  } else if (lastView && lastView.toLowerCase() === "qa/qc" && canAccessQaqc()) {
    router.push(`/${tenantId}/qaqc`);
  } else if (lastView && lastView === "QA/QC Overview" && canAccessQaqc()) {
    const query = pickSamplesListQueryForRouter(route?.query || {});
    router.push({ path: `/${tenantId}/qaqc/overview`, query });
  } else if (section === "assets") {
    router.push(`/${tenantId}/data-management`);
  } else {
    router.push(`/${tenantId}/data-management`);
  }
}
